

import axios from 'axios';
import { URL } from '../tools/ApiRoutes';

// URL Authentication Endpoint

/**
 * Obtener tipos de proyecto
 * @return {Promise} promise
 */
const getProjectTypes = () => {
    const headers = {
        'Content-Type': 'application/json',
    };
    return axios.get(`${URL}/proyectos/tiposDeProyecto`, {}, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Obtener cuentas de Intelisis
 * @return {Promise} promise
 */
const obtenerCta = () => {
    const headers = {
        'Content-Type': 'application/json',
    };
    return axios.get(`${URL}/intelisis/obtenerCta`, {}, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Obtener conceptos de retención en la fuente
 * @return {Promise} promise
 */
const conceptosReteFuente = () => {
    const headers = {
        'Content-Type': 'application/json',
    };
    return axios.get(`${URL}/intelisis/conceptosReteFuente`, {}, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Obtener conceptos de retención ICA
 * @return {Promise} promise
 */
const conceptosReteICA = () => {
    const headers = {
        'Content-Type': 'application/json',
    };
    return axios.get(`${URL}/intelisis/conceptosReteICA`, {}, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Obtener proyectos disponibles en Intelisis
 * @return {Promise} promise
 */
const obtenerProyectos = () => {
    const headers = {
        'Content-Type': 'application/json',
    };
    return axios.get(`${URL}/intelisis/obtenerProyectos`, {}, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Obtener articulos disponibles en Intelisis
 * @return {Promise} promise
 */
const obtenerArticulos = () => {
    const headers = {
        'Content-Type': 'application/json',
    };
    return axios.get(`${URL}/intelisis/obtenerArticulos`, {}, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Registrar un articulo en Intelisis
 * @param {Object} articleData - Payload del articulo a registrar
 * @return {Promise} promise
 */
const registrarART = (articleData) => {
    const headers = {
        'Content-Type': 'application/json',
    };

    if (!articleData || typeof articleData !== 'object' || Array.isArray(articleData)) {
        throw new Error('articleData debe ser un objeto valido');
    }

    return axios.post(`${URL}/intelisis/registrarART`, articleData, { headers })
        .then(({ data }) => {
            return data;
        });
};

export const CatalogsService = {
    getProjectTypes,
    obtenerCta,
    conceptosReteFuente,
    conceptosReteICA,
    obtenerProyectos,
    obtenerArticulos,
    registrarART,
};
